import { TextField } from '../../atoms';
import { FORM_CLASSIFIERS_GOS_AUTO_EDIT } from '../../constants/formKeys';
import {
  getClassifiersTsAutoChange,
  getClassifiersTsAutoItem,
  getClassifiersTsAutoItemData,
} from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { tsAutomaticLocking } from '../../constants/parameters';
import createParameterEditor from '../createParameterEditor';

export default createParameterEditor({
  title: 'parameterTsAutoTitle',
  formKey: FORM_CLASSIFIERS_GOS_AUTO_EDIT,
  fields: [
    {
      name: tsAutomaticLocking.VALUE,
      label: 'fieldTsAuto',
      component: TextField,
      className: 'date-field',
    },
  ],
  fetchAction: actions.fetchClassifierTsAuto,
  changeAction: actions.changeClassifierTsAuto,
  getChangeSelector: getClassifiersTsAutoChange,
  getItemSelector: getClassifiersTsAutoItem,
  getInitialValues: (state) => ({
    [tsAutomaticLocking.VALUE]: getClassifiersTsAutoItemData(state),
  }),
});
